import {
    REQUEST_STATUS,
    SET_LOADING_STATUS,
    CLEAR_STATUS,
    HIDE_MENU_ITEMS,
    SHOW_MENU_ITEMS,
    SHOW_ERROR_MESSAGE,
    HIDE_ERROR_MESSAGE,
    START_LOADING,
    STOP_LOADING,
    STORE_RESPONSE_MESSAGE
} from "../../constants/global";


export const requestStatus = (status) => ({
    type: REQUEST_STATUS,
    status,
});

export const setLoadingStatus = (loading) => ({
    type: SET_LOADING_STATUS,
    loading,
});

export const clearStatus = () => ({
    type: CLEAR_STATUS
});


export const hideMenuItems = () => ({
    type: HIDE_MENU_ITEMS
});

export const showMenuItems = () => ({
    type: SHOW_MENU_ITEMS
});

export const showErrorMessage = (message) => ({
    type: SHOW_ERROR_MESSAGE,
    message
});

export const hideError = () => ({
    type: HIDE_ERROR_MESSAGE,
});

//loading
export const startLoading = () => ({ type: START_LOADING });
export const stopLoading = () => ({ type: STOP_LOADING });

//alerts
export const storeResponseMessage = (responseMessage) => ({
    type: STORE_RESPONSE_MESSAGE,
    responseMessage
})


